import React from 'react';
import { DemoButton } from '../primitives/buttons';

export const CharacterEmptyState = ({ theme, density, palette, palTheme, cardStyle, cardFinish, onAddCharacter }) => {
  const c = theme.colors;
  const t = theme.typography || {};

  return (
    <div style={{
      padding: '20px 4px 12px',
      textAlign: 'center',
    }}>
      <div style={{
        fontSize: '1.6rem',
        marginBottom: 8,
        color: palette.light,
        textShadow: `0 0 16px ${palette.glow}`,
      }}>✦</div>
      <div style={{
        fontSize: '0.96rem', color: c.textPrimary,
        fontFamily: t.headingFamily, fontWeight: 600,
      }}>You have no character in this campaign yet.</div>
      <div style={{
        fontSize: '0.82rem', color: c.textMuted, marginTop: 4,
        fontFamily: t.fontFamily, fontStyle: 'italic',
      }}>
        Add one of your solo characters or create a new one.
      </div>
      {onAddCharacter && (
        <div style={{ marginTop: 14, display: 'inline-flex' }}>
          <DemoButton theme={palTheme} icon="✦" variant="outline" onClick={onAddCharacter}>
            Add a character
          </DemoButton>
        </div>
      )}
    </div>
  );
};
